import React from 'react';
import TemplateDeckProposalCard from './TemplateDeckProposalCard';
import './conversationDeckProposal.css';

export default function ConversationDeckProposalCard(props) {
  const card = props.proposal?.card;
  if (card?.generation !== 'template-library-app-v1') return null;
  return <TemplateDeckProposalCard key={card.proposal_root_id} {...props} />;
}
